"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unpartialRecursively = exports.unpartial = exports.requiredDeep = exports.required = void 0;
function required(source1, source2, source3) {
    return merge([source1, source2, source3], function (p, e) {
        return __assign(__assign({}, p), e);
    });
}
exports.required = required;
function requiredDeep(source1, source2, source3) {
    return merge([source1, source2, source3], function (p, e) { return deepmerge(p, e); });
}
exports.requiredDeep = requiredDeep;
function merge(entries, reducer) {
    if (entries[0] === undefined || entries[0] === null)
        return entries[0];
    return entries.filter(function (x) { return !!x; }).reduce(reducer, {});
}
function deepmerge(source1, source2) {
    if (typeof source1 !== 'object' || source1 === null)
        return source2 !== undefined ? source2 : source1;
    if (Array.isArray(source1)) {
        if (Array.isArray(source2))
            return source2;
        if (source2 === undefined)
            return __spreadArray([], source1, true);
        return __spreadArray(__spreadArray([], source1, true), [source2], false);
    }
    return getAllKeys(source1).concat(getAllKeys(source2)).reduce(function (p, k) {
        // @ts-ignore
        p[k] = deepmerge(source1[k], source2 && source2[k]);
        return p;
    }, {});
}
function getAllKeys(subject, internal) {
    if (internal === void 0) { internal = false; }
    if (typeof subject !== 'object')
        return [];
    var propertyNames = Object.getOwnPropertyNames(subject);
    var keys = internal ? propertyNames.filter(function (n) { return n !== 'constructor'; }) : propertyNames;
    var proto = Object.getPrototypeOf(subject);
    return proto !== Object.prototype ? keys.concat(getAllKeys(proto, true)) : keys;
}
function unpartial(s1, s2, s3) {
    // defensive check for JS
    if (s1 === undefined || s1 === null)
        return s1;
    return [s1, s2, s3]
        .filter(notNil)
        .reduce(function (p, s) { return (__assign(__assign({}, p), trimNilProps(s))); }, {});
}
exports.unpartial = unpartial;
function trimNilProps(value) {
    return Object.keys(value).reduce(function (p, k) {
        if (notNil(value[k]))
            p[k] = value[k];
        return p;
    }, {});
}
function notNil(value) {
    return value !== null && value !== undefined;
}
function unpartialRecursively(arg1, arg2, arg3) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return requiredDeep(arg1, arg2, arg3);
}
exports.unpartialRecursively = unpartialRecursively;
//# sourceMappingURL=index.js.map